/** @format */

import TagClear from './TagClear';

export default TagClear;
